import React, { Fragment, useEffect, useState } from "react";
// import ordered from "../../assets/images/dashboard/designer.jpg";
import { queryString } from "../../utils/queryString";
import Breadcrumb from "../common/breadcrumb";
import { getOrderDetailsByOrderId } from "./../../reducers/adminReducers";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../loader/loader";

const OrderDetail = () => {
  const { id } = queryString();
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { orderDetails, boxDetails } = result;
  const [loading, setLoading] = useState(false);

  // console.log('orderDetails',orderDetails,'id',id);

  const createAddress = (data) => {
    let address = "";
    if (data) {
      [
        "firstname",
        "lastname",
        "mobile",
        "addressLine1",
        "addressLine2",
        "city",
        "state",
        "country",
        "zipCode",
      ].forEach((el) => {
        if (data[el]) {
          address = `${address ? `${address}` : address} ${data[el]}`;
        }
      });
    }
    return address;
  };
  const getOrderDetailsById = async () => {
    setLoading(true);
    const response = await dispatch(getOrderDetailsByOrderId(id));
    if (response?.payload) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrderDetailsById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const totalBoxprice = boxDetails?.reduce((acc, curr) => {
    return acc + curr?.boxId.price;
  }, 0);

  const boxNameFormatting = (name) => {
    if (!name.includes("~")) {
      return name;
    }
    const splitName = name.split("~");
    return splitName[0];
  };

  return (
    <>
      {loading && <Loader />}
      <Breadcrumb title="orderdetail" parent="orderdetail" />
      <div className="order-detail-page">
        <div className="container">
          <div className="order-detail">
            <div className="order-detail-list">
              <h4>User Details</h4>
              {orderDetails?.length > 0 &&
                orderDetails?.map((el) => (
                  <div className="user-name">
                    <p>
                      Username: <span>{el?.userId?.username}</span>
                    </p>
                    <p>
                      Phone: <span>{el?.userId?.mobile}</span>
                    </p>
                    <p>
                      Address:{" "}
                      <span>{createAddress(el?.orderId?.shippingAddress)}</span>
                    </p>
                  </div>
                ))}
            </div>
            <div className="order-detail-list">
              <h4>Order Details</h4>
              {orderDetails?.length > 0 &&
                orderDetails?.map((el) => (
                  <div className="user-name">
                    <p>
                      Order No: <span>{el?.orderId?.orderid}</span>
                    </p>
                    <p>
                      Total Order Items: <span>{el?.quantity}</span>
                    </p>
                  </div>
                ))}
            </div>
            <div className="order-detail-list">
              <h4>Box Details</h4>
              <h5 className="total-box-price">
                Total Box Price: &euro; {totalBoxprice?.toFixed(2)}
              </h5>
              {boxDetails?.length > 0 &&
                boxDetails?.map((el) => (
                  <div className="ordered-detail-list mt-4">
                    <div className="left-order-details">
                      <div className="user-name">
                        <p>
                          Box Name: <span>{boxNameFormatting(el?.boxId?.name)}</span>
                        </p>
                        <p>
                          Price: <span> &euro; {el?.boxId?.price}</span>
                        </p>
                      </div>
                    </div>
                    <div className="right-order-section">
                      <div className="ordered-items">
                        <img src={el?.boxId?.image} alt="ordered" />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="order-detail-list">
              {/* <h4>Ordered Items:</h4> */}
              {orderDetails?.length > 0 &&
                orderDetails?.map((el) => (
                  <div className="ordered-detail-list">
                    <div className="left-order-details">
                      <div className="ordered-items">
                        <img src={el?.productId?.bannerImage} alt="ordered" />
                      </div>
                    </div>
                    <div className="right-order-section">
                      <div className="user-name">
                        <p>
                          Order Name: <span>{el?.productId?.name}</span>
                        </p>
                        <p>
                          Price: &euro; <span>{el?.price}</span>
                        </p>
                        <p>
                          Quantity: <span>{el?.quantity}</span>
                        </p>
                        {el?.reason && (
                          <p>
                            Info: <span>{el?.reason}</span>
                          </p>
                        )}
                        {el?.trackOrderNumber && (
                          <>
                            <p>
                              Tracking Number:{" "}
                              <span>{el?.trackOrderNumber}</span>
                            </p>

                            <a
                              className="btn btn-primary mb-4"
                              href={`https://track.global/en/tracking/${el?.trackOrderNumber}?trackingNumber=${el?.trackOrderNumber}`}
                              target="_blank"
                              rel="noreferrer">
                              Track Order
                            </a>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetail;
